
/**
 * number_instruction_pressed
 * Тап на номер телефона в инструкции на экране "Подтвердите номер телефона"
 */
export interface NumberInstructionPressed {}

export function mapNumberInstructionPressedEvent(event: NumberInstructionPressed): object {
  const props: Record<string, unknown> = {
  };

  return {
    event: 'analytics_event',
    event_name: 'number_instruction_pressed',
    event_properties: {},
  };
}
